import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ReportTable from "./ReportTable";
import ReportsSection from "./ReportsSection1";
import ReportDropdown from "./ReportDropdown";


const data = Array(5).fill({
  date: "07/07/2025",
  opening: "20000",
  closing: "20000",
  value: "2000",
});
const renderDropdown = (type) => {
  const customLabels = {
    Seed: "Crop Report",
    Fertizilar: "Fertilizer Report",
    Herbicides: "Herbicides Report",
  };

  return (
    <div className="flex justify-end   md:gap-2 gap-[1px] md:mt-12 w-full sm:w-auto">
      <div>
        {Object.keys(dropdownItems)
          .filter((itemType) => itemType === type)
          .map((itemType) => (
            <Dropdown
              key={itemType}
              label={customLabels[itemType] || itemType}
              items={dropdownItems[itemType]}
              type={itemType}
            />
          ))}
      </div>
    </div>
  );
};
const renderTable = (title, type, dropdownType) => (
  <div className="w-full font-sans text-[10px] md:text-[32px]">
    <div className="flex justify-between items-center mb-2 md:mb-1 md:mt-5">
      <div className="flex justify-between">
        {title && (
          <div className={`${title === "INVENTORY" ? "-mb-12" : ""}`}>
            <h2 className="text-[#FFBD26] font-bold text-[8px] md:text-[20px]">
              {title}
            </h2>
          </div>
        )}
        <div className="w-10"></div>
        {dropdownItems[dropdownType] && (
          <Dropdown
            label={
              {
                Seed: "Crop Report",
                Fertilizer: "Fertilizer Report",
                Herbicides: "Herbicides Report",
              }[dropdownType] || dropdownType
            }
            items={dropdownItems[dropdownType]}
            type={dropdownType}
          />
        )}
      </div>
    </div>

    <table className="w-full table-fixed  border-separate border-spacing-y-1 md:-mt-3">
      <thead>
        <tr>
          <th className="text-left font-bold w-auto md:w-[140px] text-[6px] md:text-[20px]">
            {type.toUpperCase()}
          </th>
          <th className="text-left font-normal w-auto md:w-[140px]">
            Opening Stock <strong>(t)</strong>
          </th>
          <th className="text-left font-normal w-auto md:w-[140px]">
            Closing Stock <strong>(t)</strong>
          </th>
          <th className="text-left font-normal w-auto md:w-[140px]">
            Value <strong>(USD)</strong>
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px]">
              {row.date}
            </td>
            <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px] bg-[#E7EBEB]">
              {row.opening}
            </td>
            <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px] bg-[#CFD7D7]">
              {row.closing}
            </td>
            <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px] bg-[#9FAFAF] text-black">
              {row.value}
            </td>
          </tr>
        ))}
        <tr>
          <td className="h-[5px]"></td>
        </tr>
        <tr className="font-bold">
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px]">TOTAL</td>
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px] bg-[#E7EBEB]">20000</td>
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px] bg-[#CFD7D7]">20000</td>
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px] bg-[#9FAFAF] text-black">2000</td>
        </tr>
      </tbody>
    </table>
  </div>

);
const Dropdown = ({ label, items, type }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(items[0]);

  const icon = dropdownIcons[type];

  return (
    <div className="flex flex-col w-full relative ">

      {/* Label */}
      <label className="md:text-[24px] font-bold text-[6px] text-black mb-1 md:mb-1">
        {label}
      </label>

      {/* Button + Icon Container */}
      <div className="flex relative z-20 w-fit">
        {/* Dropdown Button */}
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="xl:w-[161px] lg:w-[140px] md:w-[55px] w-[40px] h-[15px] md:h-[60px] bg-[#2E453D] text-white font-bold flex justify-between items-center px-3 rounded-l-[10px]"
        >
          <span className="md:text-[12px] md:px-4 text-[4px] md:mt-0 mt-[2px]">{selected}</span>
        </button>

        {/* Icon Box */}
        <div
          className="w-[20px] h-[15px] md:h-[40px] md:w-[40px] bg-[#152C24] text-white flex justify-center items-center rounded-[10px] -ml-2 z-30 cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
            alt="expand"
            className="w-3 h-3 md:w-5 md:h-5"
          />
        </div>
      </div>

      {/* Dropdown List */}
      {/* Dropdown List */}
      <AnimatePresence>
        {isOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full mt-1 left-0 z-50 md:w-[180px] w-[100px] bg-white/90 rounded-lg shadow-lg"
          >
            {items.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  setSelected(item);
                  setIsOpen(false);
                }}
                className="md:p-3 p-1 bg-[#CFD7D7] md:mt-1 md:text-[18px] text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
              >
                <img src={icon} className="md:w-4 md:h-4 h-2 w-2 mr-2" alt="icon" />
                <span className="text-black">{item}</span>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>

      {/* Hint Text */}


    </div>



  );
};

const dropdownItems = {
  COUNTRY: [
    "SOUTH AFRICA",
    "Botswana",
    "Cameroon",
    "Congo Democratic Republic (DRC)",
    "Cote-divorie",
    "Eswatini (Swaziland)",
    "Ethiopia",
    "Ghana",
    "Kenya",
    "Lesotho",
    "Malawi",
    "Mozambique",
    "Namibia",
    "Nigeria",
    "Rwanda",
    "Senegal",
    "Sierra Leone",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Tanzania",
    "Uganda",
    "Zambia",
    "Zimbabwe",
  ],
  REGION: [
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",


    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
  ],
  PROJECT: [
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR", "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR", "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
  ],

  CROP: [
    "MAIZE",
    "Apples",
    "Avocado",
    "Bananas",
    "Beans",
    "Cabbages",
    "Kale",
    "Mangoes",
    "Onions",
    "Passion Fruits",
    "Papaya",
    "Potatoes",
    "Strawberries",
    "Tomatoes",
    "Watermelon",
  ],
  LIVESTOCK: [
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
  ],
  DATA: [
    "PRODUCTION", "Revenue", "Inventory"],
};

const dropdownIcons = {
  COUNTRY:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744492909/Pin_alt_ioedjs.png",
  REGION:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
  CROP:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
  DATA:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
  PROJECT:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493133/image_fdtjzb.png",
  LIVESTOCK:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493189/image_34_zwohkn.png",
};

const HeatMap = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleDropdown = () => setIsOpen(!isOpen)

  const dropdownItems = [
    { text: "pdf", icon: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745106834/Order_e4ljpn.png" },
    { text: "CSV", icon: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745106834/Order_e4ljpn.png" },
    { text: "Excel", icon: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745106834/Order_e4ljpn.png" }
  ]
  const data = Array(5).fill({
    date: "07/07/2025",
    opening: "20000",
    closing: "20000",
    value: "2000",
  });
  return (
    <div className='bg-white'>
      <div className="p-6 md:px-28 px-4">
        <div className="md:-mb-5">
          <ReportsSection />
        </div>
        <div className="flex justify-between items-center md:mb-4 md:-mt-0 -mt-6">
          <h2 className="md:text-[32px] text-[14px] font-bold md:mb-2"><span className="text-[#979797]">Outlook | </span>SOUTH AFRICA</h2>
          <div className="flex items-center flex-shrink-0 md:mt-0 md:pr-0 pr-3 mt-3">
            <p className="md:text-[16px] text-[5px] bg-[#2E453D]   text-white px-2 md:w-[240px] md:py-[9px]  md:px-4 py-[3px] md:rounded-tl-md rounded-tl-md font-bold md:rounded-bl-md rounded-bl-md whitespace-nowrap">
              RUN REPORT
            </p>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
              alt="Expand"
              className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] md:flex hidden object-contain md:rounded-tr-md rounded-tr-md font-bold md:rounded-br-md bg-[#FFBD26] px-2 md:py-2"
            />
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
              alt="Expand"
              className="w-[20px] h-[13px] md:hidden py-[1px] flex md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
            />
          </div>
        </div>

        {/* ADMINISTRATIVE Section */}
        <div className="mb-6 md:mt-0 mt-3">
          {/* Flex container with label and grid in one row */}
          <div className="flex md:flex-row items-start gap-1 md:gap-28">
            {/* ADMINISTRATIVE label on the left */}
            <div className=" w-[90px] md:w-[200px]">
              <p className="text-[#FFBD26] font-bold text-[10px] md:text-[20px]">PROVINCES</p>
            </div>

            {/* Grid Header on the right */}
            <div className="grid grid-cols-9 md:grid-cols-9 md:gap-[10px] gap-[20px] flex-1">
              {[
                'GAUTENG', 'NORT WEST', 'FREE STATE', 'WESTERN CAPE', 'NOTHERN CAPE',
                'EASTERN CAPE', 'KWAZULU NATAL', 'LIMPOPO', 'MPUMALA NGA'
              ].map((region, i) => (
                <div key={i} className="text-[4px] md:text-[12px] border-b-[3px]  border-[#979797] rounded-[5px] text-black font-extrabold px-1 text-center md:w-[95px]">
                  {region}
                </div>
              ))}
            </div>
          </div>

          {/* Section Title - PROJECTS */}
          <div className="mt-2">
            <p className="text-[#FFBD26] font-bold mb-2 text-[10px] md:text-[20px]">ENTERPRISE</p>
            <div className='md:h-[2.5px] h-[1px] bg-black/50'></div>

            {/* Make full grid scrollable horizontally on mobile */}
            <div className="overflow-x-auto">
              <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)]  gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3 ">
                {['Large Enterprises / Commercial farmers', 'Medium Enterprises / Emerging farmers', 'Small Enterprises / Small holder farmers',].map((label, i) => (
                  <React.Fragment key={i}>
                    <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                      <span className="font-bold">{label.split('/')[0].trim()}</span> / {label.split('/')[1].trim().split(' ')[0]}
                      <br />
                      {label.split('/')[1].trim().split(' ').slice(1).join(' ')}
                    </div>



                    {[...Array(9)].map((_, j) => (
                      <div
                        key={j}
                        className={`h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center ${i === 1 || i === 2 ? 'mb-2 md:mb-4' : ''
                          }`}
                      >
                        {(i === 2 || i === 3) ? '345' : '345'}
                      </div>
                    ))}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>



        {/* MARKET ASSURANCE Section */}
        <div className="mt-2">
          <p className="text-[#FFBD26] font-semibold mb-2 text-[10px] md:text-[20px]">MARKET ASSURANCE</p>
          <div className='h-[2.5px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] gap-y-1 md:gap-x-2 gap-x-1 md:mt-3 mt-1">
            {[
              { label: 'Total Households', value: '345' },
              { label: 'House holds in Farming', value: '16%' },
              { label: 'House holds in waste management', value: '16%' },
              { label: 'House holds in Energy', value: '16%' }
            ].map((item, i) => (
              <React.Fragment key={i}>
                <div className={`md:text-[14px] md:w-[215px] text-[6px] text-black `}>
                  {item.label}
                </div>
                {[...Array(9)].map((_, j) => (
                  <div
                    key={j}
                    className={`md:h-7 h-4 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center `}
                  >
                    {item.value}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>





        <div className="mb-3 md:mt-6 mt-3">
          <p className="font-semibold md:text-[20px] text-[10px] text-[#FFBD26] mb-1">EMPLOYMENT</p>
          <div className='md:h-[2.5px] h-[1px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)]  grid-cols-[90px_repeat(9,1fr)] gap-y-1 md:gap-x-2 gap-x-1 md:mt-3 mt-1 items-center">
            <h1 className="md:text-[14px] text-[8px] text-black">Unemployment rate</h1>

            {[
              '28.6%', '36.6%', '31.9%', '34.7%', '37.9%', '19.6%', '36.6%', '27.4%', '41.3%'
            ].map((value, j) => {
              const isRedBox = [1, 4, 6, 8, 9].includes(j + 1); // Boxes with red text on light bg
              const isWhiteOnRed = [2, 5, 7].includes(j + 1);   // Boxes with white text on red bg

              return (
                <div
                  key={j}
                  className={`
            md:h-7 h-4 rounded-md text-[6px] md:text-[16px] flex items-center justify-center
            ${isWhiteOnRed ? 'bg-[#CFD7D7] text-[black]' : 'bg-[#CFD7D7] text-[black]'}
          `}
                >
                  {value}
                </div>
              );
            })}
          </div>
        </div>

        <ReportDropdown />
        <div className="flex justify-between items-center">
          <div>
            <h1 className="font-bold text-[10px] md:text-[14px] md:w-[200px]">Totals</h1>
          </div>
          <div className="bg-[#F3F5F5] border-b-[3px] border-[#979797] rounded-[5px] md:w-[195px] w-[50px] h-[20px] md:h-[41px] flex items-center justify-center">
            <h1 className="text-black font-bold  text-[8px] md:text-[18px]">7</h1>
          </div>
          <div className="bg-[#F3F5F5] border-b-[3px] border-[#979797] rounded-[5px] md:w-[195px] w-[50px] h-[20px] md:h-[41px] flex items-center justify-center">
            <h1 className="text-black font-bold text-[8px] md:text-[18px]">10</h1>
          </div>
          <div className="bg-[#F3F5F5] border-b-[3px] border-[#979797] rounded-[5px]md:w-[195px] w-[50px] h-[20px] md:h-[41px] flex items-center justify-center">
            <h1 className="text-black font-bold text-[8px]  md:text-[18px]">18</h1>
          </div>
          <div className="bg-[#F3F5F5] border-b-[3px] border-[#979797] rounded-[5px] md:w-[195px] w-[50px] h-[20px] md:h-[41px] flex items-center justify-center">
            <h1 className="text-black font-bold text-[8px]  md:text-[18px]">200ha</h1>
          </div>
          <div className="bg-[#F3F5F5] border-b-[3px] border-[#979797] rounded-[5px]md:w-[195px] w-[50px] h-[20px] md:h-[41px] flex items-center justify-center">
            <h1 className="text-black font-bold  text-[8px]  md:text-[18px]">230</h1>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center md:mt-10 mt-4 gap-2">
          <div>
            <h1 className="font-bold text-[10px] md:text-[20px] md:w-[200px] text-[#FFBD26]">CHALLENGES</h1>
          </div>

          <div className="flex md:flex-row md:gap-1  gap-1 w-full">
            {/* Pair 1 */}
            <div className="flex items-center w-full md:w-fit mb-2 md:mb-0">
              <div className="w-full md:w-[140px] bg-[#CFD7D7] text-black font-normal flex md:px-2 px-1 items-center rounded-l-[5px] h-[20px] md:h-[40px]">
                <span className="text-[4px] md:text-[12px] w-full md:w-[100px]">Access to markets</span>
              </div>
              <div className="w-full md:w-[150px] xl:w-[55px] bg-[#152C24] text-white flex items-center justify-center rounded-r-[5px] md:px-2  px-1 h-[20px] md:h-[40px]">
                <span className="text-[4px] md:text-[14px]">75%</span>
              </div>
            </div>

            {/* Pair 2 */}
            <div className="flex items-center w-full md:w-fit mb-2 md:mb-0">
              <div className="w-full md:w-[140px] bg-[#CFD7D7] text-black font-normal flex md:px-2 px-1 items-center rounded-l-[5px] h-[20px] md:h-[40px]">
                <span className="text-[4px] md:text-[12px] w-full md:w-[100px]">COMPLIANCE</span>
              </div>
              <div className="w-full md:w-[150px] xl:w-[55px] bg-[#152C24] text-white flex items-center justify-center rounded-r-[5px] md:px-2  px-1 h-[20px] md:h-[40px]">
                <span className="text-[4px] md:text-[14px]">55%</span>
              </div>
            </div>

            {/* Pair 3 */}
            <div className="flex items-center w-full md:w-fit mb-2 md:mb-0">
              <div className="w-full md:w-[140px] bg-[#CFD7D7] text-black font-normal flex md:px-2 px-1 items-center rounded-l-[5px] h-[20px] md:h-[40px]">
                <span className="text-[4px] md:text-[12px] w-full md:w-[120px]">MARKET ACCESS</span>
              </div>
              <div className="w-full md:w-[150px] xl:w-[55px] bg-[#152C24] text-white flex items-center justify-center rounded-r-[5px] md:px-2  px-1 h-[20px] md:h-[40px]">
                <span className="text-[4px] md:text-[14px]">33%</span>
              </div>
            </div>

            {/* Pair 4 */}
            <div className="flex items-center w-full md:w-fit mb-2 md:mb-0">
              <div className="w-full md:w-[140px] bg-[#CFD7D7] text-black font-normal flex md:px-2 px-1 items-center rounded-l-[5px] h-[20px] md:h-[40px]">
                <span className="text-[4px] md:text-[12px] w-full md:w-[100px]">SKILL GAPS</span>
              </div>
              <div className="w-full md:w-[150px] xl:w-[55px] bg-[#152C24] text-white flex items-center justify-center rounded-r-[5px] md:px-2  px-1 h-[20px] md:h-[40px]">
                <span className="text-[4px] md:text-[14px]">45%</span>
              </div>
            </div>

            {/* Pair 5 */}
            <div className="flex items-center w-full md:w-fit mb-2 md:mb-0">
              <div className="w-full md:w-[140px] bg-[#CFD7D7] text-black font-normal flex md:px-2 px-1 items-center rounded-l-[5px] h-[20px] md:h-[40px]">
                <span className="text-[4px] md:text-[12px] w-full md:w-[100px]">TECHNOLOGY</span>
              </div>
              <div className="w-full md:w-[150px] xl:w-[55px] bg-[#152C24] text-white flex items-center justify-center rounded-r-[5px] md:px-2  px-1 h-[20px] md:h-[40px]">
                <span className="text-[4px] md:text-[14px]">41%</span>
              </div>
            </div>
          </div>
        </div>
        <div className='md:h-[2.5px] h-[1px] bg-black/50 md:mt-2'></div>

        <div className="md:mt-5 mt-3">
          <div className="md:text-[14px] text-[10px] text-black">
            <p className="font-bold ">Access to Finance</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>One of the biggest hurdles for SMEs.</li>
              <li>Many lack collateral or formal credit history.</li>
              <li>Struggles to qualify for traditional funding from banks.</li>
              <li>Limited access to government grants, venture capital, or microfinance.</li>
            </ul>
            <p className="font-normal md:mt-1 ">*Survey-Realtime updates.</p>

          </div>

        </div>
        <div className="flex justify-between items-center mt-3  md:mt-6">
          <div>
            <h2 className="text-[14px] md:text-[36px] font-bold text-black">
              Reports
            </h2>
          </div>
          <div className="relative inline-block text-left ">
            {/* Toggle Button */}
            <a href="/MoreReportPage3">
              <button
                onClick={toggleDropdown}
                className="md:text-[24px] text-[8px] font-normal italic flex items-center gap-2 md:gap-5 md:px-2"
              >
                <span>Share report</span>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745106072/reply_all_ob1scz.png"
                  alt="icon"
                  className="md:w-[36px] md:h-[34px] w-[10px] h-[10px]"
                />
              </button>
            </a>


            {/* Dropdown */}
            {isOpen && (
              <div className="absolute mt-2 w-40 md:w-60 bg-white border border-gray-200 rounded-lg shadow-md z-50">
                {dropdownItems.map((item, idx) => (
                  <div
                    key={idx}
                    className="flex items-center justify-between px-2 py-1 mt-1  hover:bg-gray-100 cursor-pointer"
                  >
                    <div className="flex items-center space-x-2">
                      <img src={item.icon} alt={item.text} className="w-4 h-4 md:w-6 md:h-6" />
                      <span className="text-[10px] md:text-[24px]">{item.text}</span>
                    </div>
                    <span className="text-[10px] md:text-[24px] ">Share</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <p className="md:text-[24px] text-[8px] font-bold text-[#F38323] md:mt-6 md:mb-0 mb-5 mt-5">
          <span className="font-bold text-black">Goal:</span> Country Value chain stakeholders gain visibility of entire farming life cycle
        </p>
        <ReportTable />
      </div>
    </div>
  );
};

export default HeatMap;